import PropTypes from 'prop-types';
import ToolTip, {tooltipPositions} from './ToolTip.jsx';
import EmailAPIfrom from 'api/email.jsx';
import analysisApi from 'api/analysis';
import session from 'services/sessionService';
import emailPrefsApi from 'api/customerEmailPref';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import ReportLinkHelper from 'helpers/reportLinkHelper';
import {emailSummary} from 'page/analysis/reportDetailedView';
import events from 'lib/events';
import React from 'react';
import SimpleSpinner from './simpleSpinner.jsx';

class EmailPrefs extends React.Component {
  static displayName = 'EmailPrefs';

  static propTypes = {
    customer: PropTypes.object.isRequired,
    products: PropTypes.any.isRequired,
    email: PropTypes.string.isRequired,
    enableLastWaterTest: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    dealer: PropTypes.object.isRequired,
  };

  state = {
    loading: false,
    expanded: false,
    contactPrefs: null,
    buttonEnabled: this.props.enableLastWaterTest,
  };

  getEmailPrefs = () => {
    if (!this.state.expanded && !this.state.contactPrefs) {
      this.setState({
        loading: true,
      });
      emailPrefsApi.getPrefs(this.props.email).then(prefs => {
        this.setState({
          contactPrefs: prefs,
          expanded: !this.state.expanded,
        });
      }).catch(err => {
        console.error(err);
        events.publish('error.user', {message: 'Failed to get email preferecnes'});
      }).complete(() => {
        this.setState({
          loading: false,
        });
      });
    } else {
      this.setState({
        expanded: !this.state.expanded,
      });
    }
  };

  emailLastTest = () => {
    let {intl} = this.props;
    let {formatMessage} = intl;

    this.setState({
      loading: true,
    });
    analysisApi.getCustomerLatest(this.props.customer.id)
      .then(analysis => {
        //if no analysis, disable button
        if (analysis === null) {
          this.setState({
            buttonEnabled: false,
            loading: false,
          });
          events.publish('error.user', {message: formatMessage({id: 'customer.emailprefs.error.noanalysis'})});
          return;
        }
        let pool;
        //Find pool which matches pool of most recent analysis

        this.props.customer.pools.map((p) => {
          if (p.id === analysis.poolID) {
            pool = p;
          }
        });
        //get URL for report
        ReportLinkHelper.getReportLink(analysis.id, intl.locale)
          .then(reportURL => {
            //generate data object for analysis email
            const data = emailSummary(intl, analysis, pool, this.props.products, this.props.dealer, session.getBranch(this.props.customer.branchID));

            EmailAPIfrom.analysis(this.props.email, analysis.id, data,
              formatMessage({id: 'customer.emailprefs.last.testtitle'}), reportURL.response).then(() => {
                events.publish('success.user', {message: formatMessage({id: 'customer.emailprefs.last.emailed'}) + ' ' + this.props.email});
              }).catch(err => {
                console.error(err);
                events.publish('error.user', {message: <FormattedMessage id='customer.emailprefs.error.send' />});
              }).complete(() => {
                this.setState({
                  loading: false,
                });
              });
          });
      });
  };

  render() {
    let spinner = this.state.loading ?
      <div className='spinner-wrapper'>
        <SimpleSpinner scale={0.4} color='#008cd6'/>
      </div> : null;

    return <div className='col-md-12'>
      <div className='form-group email-prefs'>
        <label>
          <FormattedMessage id="customer.emailprefs.title"/>
          <ToolTip title={this.props.intl.formatMessage({id: 'customer.emailprefs.tooltip'})}
                   position={tooltipPositions.rightTop} iconOnly/>
        </label>
        <i className={'bl bl-dropdown ' + (this.state.expanded ? 'spin-chev' : '')}
           onClick={this.getEmailPrefs}
        />
        <a onClick={() => {
          if (this.state.buttonEnabled) {
            this.emailLastTest();
          }
        }} className={this.state.buttonEnabled ? 'last-test-button' : 'last-test-button-disable'}>
          {spinner}
          <FormattedMessage id='customer.emailprefs.last.test'/>
        </a>
        {this.state.expanded ?
          <div className='emil-pref-expanded'>
            <div className='preference-data'>
              <i className={this.state.contactPrefs.LatestFromBioguard ? 'bl bl-checkmark' : 'bl bl-x'}/>
              <div><FormattedMessage id='customer.emailprefs.latest.bioguard'/><sup>&reg;</sup></div>
            </div>
            <div className='preference-data'>
              <i className={this.state.contactPrefs.AccountUpdate ? 'bl bl-checkmark' : 'bl bl-x'}/>
              <div><FormattedMessage id='general.alex'/><sup>&reg;</sup> <FormattedMessage
                id='customer.emailprefs.prowater.emails'/></div>
            </div>
            <div className='preference-data'>
              <i className={this.state.contactPrefs.NewsFromExpert ? 'bl bl-checkmark' : 'bl bl-x'}/>
              <div><FormattedMessage id='customer.emailprefs.news'/><sup>&reg;</sup></div>
            </div>
          </div> : ''}
      </div>
    </div>;
  }
}

export default injectIntl(EmailPrefs);
